export const LICENSE_AGREEMENT_CONTENT = {
  title: 'ЛИЦЕНЗИОННОЕ СОГЛАШЕНИЕ\nС КОНЕЧНЫМ ПОЛЬЗОВАТЕЛЕМ',
  updatedAt: 'Дата последнего обновления: 08.09.2026',
  blocks: [
    {
      type: 'paragraph',
      text: 'Настоящее Лицензионное соглашение с конечным пользователем (далее — «Лицензионное Соглашение») является неотъемлемой частью Пользовательского соглашения, размещённого на сайте https://strategikon.cloud, и регулирует порядок предоставления Пользователю прав использования Игры, включая порядок приобретения Прав на неактивированные Данные и Команды.'
    },
    {
      type: 'paragraph',
      text: 'Используя Сайт и/или проходя регистрацию в Игре, Пользователь даёт своё полное и безоговорочное согласие с условиями настоящего Лицензионного Соглашения.'
    },
    {
      type: 'paragraph',
      text: 'Термины и определения, используемые в настоящем Лицензионном Соглашении, имеют значения, указанные в Политике конфиденциальности и Пользовательском соглашении, если иное прямо не установлено в настоящем Соглашении.'
    },
    {type: 'heading', text: '1. Предмет Лицензионного Соглашения'},
    {
      type: 'paragraph',
      text: '1.1. Администрация предоставляет Пользователю на условиях простой (неисключительной) лицензии право использования Игры в пределах функциональных возможностей, предусмотренных сценарием Игры.'
    },
    {
      type: 'paragraph',
      text: '1.2. Право использования Игры предоставляется Пользователю на возмездной основе в части доступа к неактивированным Данным и Командам и на безвозмездной основе в части доступа к базовому игровому процессу, если иное не предусмотрено Сайтом.'
    },
    {
      type: 'paragraph',
      text: '1.3. Настоящее Лицензионное Соглашение является договором присоединения. Пользователь принимает все условия Лицензионного Соглашения в целом без каких-либо изъятий и ограничений.'
    },
    {type: 'heading', text: '2. Права на деактивированные данные и команды'},
    {
      type: 'paragraph',
      text: '2.1. Права на неактивированные Данные и Команды - это предусмотренные настоящим Лицензионным Соглашением права на использование данных, команд (в частности: внутриигровой валюты, премиум-аккаунта, игровых предметов, внутриигровых достижений и иных виртуальных объектов) и порождаемых ими аудиовизуальных отображений Игры, активируемых последовательно для получения Пользователем определённого результата, предусмотренного сценарием Игры, приобретаемые Пользователем после внесения установленного лицензионного платежа.'
    },
    {
      type: 'paragraph',
      text: '2.2. Приобретая Права на неактивированные Данные и Команды, Пользователь получает ограниченную, личную, непередаваемую, отзывную лицензию на их использование исключительно в рамках Игры и исключительно в течение срока действия Учётной записи Пользователя.'
    },
    {
      type: 'paragraph',
      text: '2.3. Право собственности на неактивированные Данные и Команды не переходит к Пользователю. Все неактивированные Данные и Команды остаются исключительной собственностью Администрации.'
    },
    {
      type: 'paragraph',
      text: '2.4. Пользователь не приобретает никаких имущественных прав на неактивированные Данные и Команды, в том числе:'
    },
    {type: 'listItem', text: 'права владения;'},
    {
      type: 'listItem',
      text: 'права распоряжения (включая право продажи, дарения, обмена, передачи, отчуждения любым способом);'
    },
    {
      type: 'listItem',
      text: 'права на получение денежной компенсации за неиспользованные неактивированные Данные и Команды.'
    },
    {type: 'paragraph', text: '2.5. Пользователь не вправе:'},
    {
      type: 'listItem',
      text: 'осуществлять отчуждение Права на неактивированные Данные и Команды любым способом третьим лицам;'
    },
    {
      type: 'listItem',
      text: 'продавать, дарить, обменивать, передавать во временное пользование, сдавать в аренду или иным образом распоряжаться неактивированными Данными и Командами;'
    },
    {
      type: 'listItem',
      text: 'выводить внутриигровую валюту или иные неактивированные Данные и Команды за пределы Игры;'
    },
    {type: 'listItem', text: 'обменивать внутриигровую валюту на денежные средства или иное имущество;'},
    {
      type: 'listItem',
      text: 'совершать сделки с неактивированными Данными и Командами вне игровой среды, предусмотренной Администрацией.'
    },
    {
      type: 'paragraph',
      text: '2.6. Любые попытки совершения действий, указанных в п. 2.5 настоящего Лицензионного Соглашения, являются нарушением условий Лицензионного Соглашения и влекут применение мер ответственности, включая блокировку Учётной записи и аннулирование Прав на неактивированные Данные и Команды без возврата уплаченных денежных средств.'
    },
    {type: 'heading', text: '3. Внутриигровая валюта'},
    {
      type: 'paragraph',
      text: '3.1. Виртуальная валюта — виртуальная внутриигровая единица, которая не имеет денежной стоимости и не подлежит денежной оценке, хотя и имеет цену на момент приобретения. Виртуальная валюта не является средством платежа.'
    },
    {
      type: 'paragraph',
      text: '3.2. Виртуальная валюта существует исключительно в рамках Игры и используется только для активации неактивированных Данных и Команд в соответствии со сценарием Игры.'
    },
    {
      type: 'paragraph',
      text: 'Виртуальная валюта даёт Пользователю «ограниченное право использования», предоставляемое в рамках лицензии, а не товар или услугу.'
    },
    {type: 'paragraph', text: '3.3. Виртуальная валюта не является:'},
    {type: 'listItem', text: 'денежными средствами в каком-либо значении;'},
    {
      type: 'listItem',
      text: 'цифровой валютой в значении Федерального закона от 31.07.2020 № 259-ФЗ «О цифровых финансовых активах, цифровой валюте и о внесении изменений в отдельные законодательные акты Российской Федерации»;'
    },
    {type: 'listItem', text: 'объектом гражданских прав в значении статьи 128 Гражданского кодекса РФ;'},
    {type: 'listItem', text: 'имуществом или имущественным правом.'},
    {
      type: 'paragraph',
      text: '3.4. Администрация не является организатором азартных игр или лотерей. Деятельность Сайта не подпадает под действие Федерального закона от 29.12.2006 № 244-ФЗ «О государственном регулировании деятельности по организации и проведению азартных игр», так как:'
    },
    {type: 'listItem', text: 'игровой процесс не основан на риске потери денежных средств (ставке);'},
    {
      type: 'listItem',
      text: 'Пользователь получает заранее определённые (ко всем внутриигровым товарам прикреплено точное описание с вероятностью получения того или иного Права на неактивированные Данные и Команды, указанные в %), в том числе случайные в рамках игровой механики, Права на неактивированные Данные и Команды, а не денежный выигрыш.'
    },
    {
      type: 'listItem',
      text: 'Все вероятности получения неактивированных Данных и Команд опубликованы на Сайте и Пользователь с ними ознакомлен.'
    },
    {
      type: 'listItem',
      text: 'Права на неактивированные Данные и Команды не имеют реальной денежной стоимости и не могут быть обменены на денежные средства.'
    },
    {type: 'heading', text: '4. Порядок приобретения прав на неактивированные Данные и Команды'},
    {
      type: 'paragraph',
      text: '4.1. Приобретение Прав на неактивированные Данные и Команды осуществляется Пользователем исключительно в Магазине, расположенном на Сайте Игры.'
    },
    {
      type: 'paragraph',
      text: '4.2. Для приобретения Прав на неактивированные Данные и Команды Пользователь совершает следующие действия:'
    },
    {
      type: 'paragraph',
      text: '4.2.1. Выбирает в Магазине набор неактивированных Данных и Команд, которые желает активировать.'
    },
    {
      type: 'paragraph',
      text: '4.2.2. Ознакамливается с ценой лицензионного платежа, указанной в российских рублях или иной валюте по выбору платёжной системы. Ознакамливается с вероятностью получения того или иного Права на неактивированные Данные и Команды.'
    },
    {
      type: 'paragraph',
      text: '4.2.3. Подтверждает своё намерение приобрести Права на выбранные неактивированные Данные и Команды путём нажатия соответствующей кнопки («Купить», «Приобрести» или аналогичной).'
    },
    {
      type: 'paragraph',
      text: '4.2.4. Осуществляет оплату лицензионного платежа через платёжные системы, указанные на Сайте.'
    },
    {type: 'paragraph', text: '4.2.5. Получает подтверждение оплаты от платёжной системы.'},
    {
      type: 'paragraph',
      text: '4.3. Моментом заключения договора о приобретении Прав на неактивированные Данные и Команды является момент получения Администрацией подтверждения от платёжной системы об успешном списании денежных средств со счёта Пользователя (или с использованием иного способа оплаты).'
    },
    {
      type: 'paragraph',
      text: '4.4. После получения подтверждения оплаты Администрация зачисляет Виртуальную валюту и/или активирует соответствующие Права на неактивированные Данные и Команды на Учётной записи Пользователя в разумный срок, но не позднее 24 (двадцати четырёх) часов с момента получения подтверждения.'
    },
    {
      type: 'paragraph',
      text: '4.5. В случае возникновения технических ошибок при зачислении Виртуальной валюты или активации Прав Пользователь обязуется незамедлительно уведомить Администрацию по адресу электронной почты, указанному в настоящем Лицензионном Соглашении. Администрация обязуется устранить ошибку в разумный срок после получения уведомления и подтверждения факта оплаты.'
    },
    {type: 'heading', text: '5. Цена и порядок оплаты'},
    {
      type: 'paragraph',
      text: '5.1. Цена лицензионного платежа за Права на неактивированные Данные и Команды устанавливается Администрацией в одностороннем порядке и указывается в Премиум-магазине на момент совершения покупки.'
    },
    {
      type: 'paragraph',
      text: '5.2. Администрация вправе в любое время изменять цены на Права на неактивированные Данные и Команды. Изменение цен не распространяется на покупки, совершённые до вступления изменений в силу.'
    },
    {
      type: 'paragraph',
      text: '5.3. Оплата Прав на неактивированные Данные и Команды осуществляется через платёжные системы, указанные на Сайте. Пользователь обязуется использовать только те способы оплаты, которые прямо предусмотрены на Сайте.'
    },
    {
      type: 'paragraph',
      text: '5.4. Пользователь несёт полную ответственность за правильность предоставленных платёжных данных и за сохранность своих платёжных реквизитов.'
    },
    {
      type: 'paragraph',
      text: '5.5. Все лицензионные платежи осуществляются в российских рублях, указанной на Сайте.'
    },
    {
      type: 'paragraph',
      text: '5.6. Пользователь обязан оплатить все применимые налоги и сборы, связанные с приобретением Прав на неактивированные Данные и Команды, если такие налоги и сборы предусмотрены законодательством.'
    },
    {type: 'heading', text: '6. Окончательный характер покупок. Отказ от права на возврат.'},
    {
      type: 'paragraph',
      text: '6.1. Все приобретения Прав на неактивированные Данные и Команды являются окончательными и не подлежат возврату или обмену.'
    },
    {type: 'paragraph', text: '6.2. Пользователь настоящим признаёт и соглашается с тем, что:'},
    {
      type: 'paragraph',
      text: '6.2.1. С момента зачисления Виртуальной валюты и/или активации Прав на неактивированные Данные и Команды на Учётной записи Пользователя услуга по предоставлению лицензии считается оказанной надлежащим образом и в полном объёме.'
    },
    {
      type: 'paragraph',
      text: '6.2.2. Пользователь не вправе требовать возврата денежных средств, уплаченных за Права на неактивированные Данные и Команды, по основаниям, включая, но не ограничиваясь:'
    },
    {type: 'listItem', text: 'неиспользование или частичное использование приобретённых Прав;'},
    {type: 'listItem', text: 'изменение игровых предпочтений;'},
    {type: 'listItem', text: 'прекращение использования Игры Пользователем;'},
    {type: 'listItem', text: 'блокировку Учётной записи по вине Пользователя;'},
    {type: 'listItem', text: 'прекращение или приостановку оказания услуг по Игре.'},
    {
      type: 'paragraph',
      text: '6.3. Исключения из правила об окончательном характере покупок могут быть предусмотрены только:'
    },
    {type: 'listItem', text: 'действующим законодательством Российской Федерации;'},
    {type: 'listItem', text: 'письменным решением Администрации, принятым в индивидуальном порядке.'},
    {
      type: 'paragraph',
      text: '6.4. Пользователь, являющийся гражданином Российской Федерации, не вправе ссылаться на положения Закона РФ от 07.02.1992 № 2300-1 «О защите прав потребителей» в части возврата товара надлежащего качества, поскольку предметом лицензионного соглашения является не товар, а право использования (лицензия), которое имеет специфическую правовую природу и не подлежит возврату в силу своего нематериального характера.'
    },
    {
      type: 'paragraph',
      text: '6.5. Пользователь подтверждает, что, осуществляя платёж, он заказывает услугу по предоставлению доступа к функционалу Игры, которая оказывается в момент зачисления валюты. Отказ от услуги надлежащего качества не допускается.'
    },
    {
      type: 'paragraph',
      text: '6.6. Пользователь подтверждает, что до совершения покупки он был надлежащим образом ознакомлен со всеми условиями настоящего Лицензионного Соглашения, включая условия об окончательном характере покупок и отсутствии права на возврат, и согласен с ними.'
    },
    {
      type: 'paragraph',
      text: '6.7. Пользователь признаёт, что любой платеж или покупка на Сайте или в Игре совершается в целях развлечения, а не инвестирования.'
    },
    {type: 'heading', text: '7. Прекращение доступа и аннулирование прав'},
    {
      type: 'paragraph',
      text: '7.1. Пользователь признаёт и соглашается с тем, что доступ Пользователя к Игре и к приобретённым Правам на неактивированные Данные и Команды может быть прекращён в соответствии с Политикой Конфеденциальности или Лицензионным соглашением.'
    },
    {
      type: 'paragraph',
      text: '7.2. В случае прекращения доступа к Игре по любой причине (в том числе в связи с удалением Учётной записи, блокировкой, прекращением действия Соглашения, прекращением функционирования Игры) все приобретённые Права на неактивированные Данные и Команды аннулируются без возврата уплаченных денежных средств.'
    },
    {
      type: 'paragraph',
      text: '7.3. Игра может быть прекращена (отключена) Администрацией в любое время по любой причине. Пользователь признаёт и соглашается с тем, что такое событие не даёт Пользователю права требовать возмещения любых сумм, уплаченных за любые использованные или неиспользованные Права на неактивированные Данные и Команды.'
    },
    {
      type: 'paragraph',
      text: '7.4. При удалении Учётной записи Пользователем по собственному желанию все игровые данные, Виртуальная валюта и иные Права на неактивированные Данные и Команды, связанные с такой Учётной записью, утрачиваются безвозвратно и без права на компенсацию.'
    },
    {type: 'heading', text: '8. Ответственность сторон'},
    {
      type: 'paragraph',
      text: '8.1. Администрация предоставляет Игру и Права на неактивированные Данные и Команды «как есть» и не несёт ответственности за:'
    },
    {
      type: 'listItem',
      text: 'любые убытки Пользователя, связанные с использованием или невозможностью использования Игры;'
    },
    {type: 'listItem', text: 'несоответствие Игры ожиданиям Пользователя;'},
    {
      type: 'listItem',
      text: 'потерю игровых данных, Виртуальной валюты или иных Прав вследствие действий третьих лиц, технических сбоев или обстоятельств непреодолимой силы.'
    },
    {
      type: 'paragraph',
      text: 'Максимальная ответственность Администрации ограничена суммой, уплаченной Пользователем за последние 12 месяцев'
    },
    {
      type: 'paragraph',
      text: '8.2. Администрация не несёт ответственности за действия третьих лиц, включая платёжные системы, которые могут привести к задержкам или ошибкам при проведении платежей.'
    },
    {
      type: 'paragraph',
      text: '8.3. Пользователь несёт полную ответственность за сохранность данных своей Учётной записи (логина и пароля) и за все действия, совершённые с использованием его Учётной записи.'
    },
    {
      type: 'paragraph',
      text: '8.4. В случае возникновения споров между Пользователем и Администрацией, связанных с приобретением Прав на неактивированные Данные и Команды, такой спор подлежит разрешению в соответствии с законодательством Российской Федерации в судебном порядке по месту нахождения Администрации.'
    },
    {type: 'heading', text: '9. Заключительные положения'},
    {
      type: 'paragraph',
      text: '9.1. Настоящее Лицензионное Соглашение вступает в силу с момента акцепта Пользователем условий Лицензионного Соглашения (регистрации в Игре или первого использования Игры) и действует до момента прекращения действия Пользовательского соглашения.'
    },
    {
      type: 'paragraph',
      text: '9.2. Администрация вправе в одностороннем порядке вносить изменения в настоящее Лицензионное Соглашение. Новая редакция Лицензионного Соглашения вступает в силу с момента её размещения на Сайте.'
    },
    {
      type: 'paragraph',
      text: '9.3. Продолжая использовать Игру после внесения изменений в Лицензионное Соглашение, Пользователь подтверждает своё согласие с такими изменениями.'
    },
    {
      type: 'paragraph',
      text: '9.4. Ко всем отношениям, возникающим в связи с исполнением настоящего Лицензионного Соглашения, применяется законодательство Российской Федерации.'
    },
    {
      type: 'paragraph',
      text: '9.5. Признание судом какого-либо положения настоящего Лицензионного Соглашения недействительным не влечёт недействительности остальных положений Лицензионного Соглашения.'
    },
    {
      type: 'paragraph',
      text: '9.6. Все уведомления и сообщения в рамках настоящего Лицензионного Соглашения направляются по электронной почте на адреса, указанные в Политике конфиденциальности и Пользовательском соглашении.'
    },
    {
      type: 'paragraph',
      text: '9.7. В Игре используются счётчики статистики и рекламные пиксели сторонних сервисов (Яндекс Метрика, включая технологию записи сеансов «Вебвизор», и пиксель VK Рекламы). Они собирают сведения об использовании Игры для оценки эффективности рекламных кампаний, улучшения Игры и показа рекламы. Состав собираемых сведений, цели обработки, перечень получателей и ссылки на документы этих сервисов приведены в пунктах 4.5, 9.4–9.6 Политики конфиденциальности. Используя Игру, Пользователь соглашается с таким сбором сведений. Отказаться от сбора можно, прекратив использование Игры либо ограничив работу счётчиков средствами браузера или расширениями-блокировщиками; такое ограничение может привести к некорректной работе отдельных функций Игры.'
    },
    {type: 'heading', text: '10. Контактная инфомация'},
    {
      type: 'paragraph',
      text: 'По всем вопросам, связанным с настоящим Лицензионным Соглашением, Пользователь может обратиться:'
    },
    {type: 'paragraph', text: 'Администрация: ИП Баценков Я.С. ИНН 671406364925'},
    {type: 'paragraph', text: 'Электронная почта: strategikon.game@yandex.ru'},
    {
      type: 'paragraph',
      text: 'Пользователь подтверждает, что ознакомился с условиями настоящего Лицензионного соглашения, полностью понимает их и соглашается с ними. Пользователь подтверждает, что достиг возраста 18 лет или имеет разрешение законных представителей на заключение настоящего Лицензионного Соглашения. Пользователь подтверждает, что ему разъяснено и понятно, что приобретаемые им Права на неактивированные Данные и Команды не являются имуществом, не имеют реальной денежной стоимости, не подлежат возврату или обмену, и что в случае прекращения доступа к Игре или прекращения функционирования Игры такие Права аннулируются без компенсации.'
    },
  ],
};
